import { serialize } from './compareUtils';

export const hasOrphanedComments = (comments: unknown, content: unknown[] | undefined | null): boolean => {
  if (!Array.isArray(comments) || comments.length === 0) return false;

  const anchorIds = new Set(Object.keys(serialize({ content: content ?? [] })));
  return comments.some((comment) => comment?.onType !== 'comment' && typeof comment?.onId === 'string' && !anchorIds.has(comment.onId));
};
